function d(e) {
  return e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
function c(e, n) {
  return typeof e.isSameNode == "function" ? e.isSameNode(n) : e === n;
}
function u(e) {
  const n = e.startContainer.nodeType === Node.TEXT_NODE && e.endContainer.nodeType === Node.TEXT_NODE;
  if (e.commonAncestorContainer.nodeType === Node.TEXT_NODE)
    return n;
  if (n && c(e.commonAncestorContainer, e.startContainer.parentNode) && c(e.commonAncestorContainer, e.endContainer.parentNode)) {
    let t = e.startContainer.nextSibling;
    for (; t && t !== e.endContainer; ) {
      if (t.nodeType !== Node.TEXT_NODE)
        return !1;
      t = t.nextSibling;
    }
    return !0;
  }
  return !1;
}
function f() {
  const e = window.getSelection(), n = document.createRange();
  n.selectNodeContents(e.focusNode), n.collapse(!1), e.removeAllRanges(), e.addRange(n);
}
function N(e, n, o = 10) {
  const t = window.getSelection();
  let r = null;
  return !t || !t.anchorNode || !t.focusNode ? null : ([
    /** the Node in which the selection begins */
    t.anchorNode,
    /** the Node in which the selection ends */
    t.focusNode
  ].forEach((i) => {
    let s = o;
    for (; s > 0 && i.parentNode && !(i.tagName === e && (r = i, n && i.classList && !i.classList.contains(n) && (r = null), r)); )
      i = i.parentNode, s--;
  }), r);
}
function T(e) {
  const n = window.getSelection();
  n.removeAllRanges();
  const o = document.createRange();
  o.selectNodeContents(e), n.addRange(o);
}
function E(e, n) {
  return n === null ? !1 : e.contains(n.startContainer);
}
function g() {
  return window.getSelection ? window.getSelection().toString() : "";
}
function l(e = !1) {
  const n = window.getSelection();
  return e && n.isCollapsed ? null : n;
}
function m(e) {
  return e && e.rangeCount ? e.getRangeAt(0) : null;
}
function C() {
  return !!l().anchorNode;
}
function p(e, n) {
  if (!e)
    return !1;
  let o = e.startContainer;
  o && o.nodeType === Node.TEXT_NODE && (o = o.parentNode);
  let t = null;
  return o && o instanceof Element && (t = o.closest(n)), t ? t.nodeType === Node.ELEMENT_NODE : !1;
}
function S(e, n) {
  if (!e)
    return !1;
  let o = e.anchorNode || e.focusNode;
  o && o.nodeType === Node.TEXT_NODE && (o = o.parentNode);
  let t = null;
  return o && o instanceof Element && (t = o.closest(n)), t ? t.nodeType === Node.ELEMENT_NODE : !1;
}
function w() {
  const e = l();
  return e ? e.isCollapsed : null;
}
function h() {
  const e = l();
  if (!e)
    return null;
  const n = e.anchorNode;
  return n ? d(n) ? n.parentElement : n : null;
}
function R() {
  const e = l();
  return e && e.removeAllRanges(), e;
}
export {
  f as collapseToEnd,
  T as expandToTag,
  N as findParentTag,
  h as getAnchorElement,
  m as getRangeFromSelection,
  l as getSelection,
  g as getSelectionText,
  w as isCollapsed,
  d as isElement,
  p as isRangeAtContainer,
  E as isRangeInsideContainer,
  c as isSameNode,
  S as isSelectionAtContainer,
  C as isSelectionExists,
  u as rangeIsTextNode,
  R as removeAllRanges
};
